import React from "react";
import Loading from "./components/loading";
import Projects from "./components/Projects";


// import ripples from "./jquery.ripples-master/dist/jquery.ripples-min.js";
// import "./jquery.ripples-master/dist/jquery.ripples-min.js";
// import 'aos/dist/aos.css';
// import 'bower_components/aos/dist/aos.css';
import AOS from 'aos';
// import image from "./my_pic.jpg";
import Intro from './components/intro';
import Contact from "./components/contact";
import About from "./components/about";
// import 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';

// import coder from "./coder.svg";
// import Progress from "./components/Progress";
import './css/loading.css';
import './css/intro.css';

import './nav.js';
import './index.css';
import './responsive.css';
// import $ from 'jquery'
function App() {
  AOS.init();
  // console.log(menuBtn);
  //   menuBtn.addEventListener('click',toggleMenu);

 
  // $(function () {
  //   $('.whol').css("overflow", "hidden");
  //   var scroll=$(window).scrollTop();
  //   $(window).scroll(function () {

  //     var positiontop = $(window).scrollTop();
      // var positionbotton=$(document).scrollBottom();
      // console.log(positionbott);
      // if(scroll<positiontop)
      // {
      //   console.log(positiontop);
      //   $('#about2').addClass('animate__animated animate__infinite animate__backInDown');
        

      // console.log("scrollDown");
      // }
      // else
      // {
      //   if((positiontop<32) && (positiontop>4))
      //    $('#about2').addClass('animate__animated animate__infinite animate__backOutDown ');
      //   console.log(positiontop);
      // console.log("scrollup");
      // }
      //  scroll=positiontop;
      // if ((positiontop > 10) && (positiontop < 61)) {
      //   $('#about2').addClass('animate__animated animate__bounceInLeft');
      // }
      // // if((positiontop<58)
      // // else if((positiontop>233) &&(positiontop<248)){
      // //   $('#myface').addClass('animate__animated animate__flash');
      // // }
      // // if((positiontop>89)){
      // //   $('#what').addClass('animate__animated animate__bounceInRight');
      // // }
      // // if((positiontop>684)){
      // //   $('#bio').addClass('animate__animated animate__zoomIn');
      // // }
      // // else if((positiontop>700) && (positiontop<724)){
      // //   $('#bi').addClass('animate__animated animate__lightSpeedInRight');
      // // }
      // else if ((positiontop > 1606) && (positiontop < 1660)) {
      //   $('#proj').addClass('animate__animated animate__bounceInRight');
      // }
      // // else if((positiontop>393) && (positiontop<650)){
      // //   $('#first').addClass('animate__animated animate__backOutUp');
      // //   $('#first').addClass('animate__animated animate__bounceInRight');
      // // }
      // // else if((positiontop>950) && (positiontop<984)){
      // //   $('#ski').addClass('animate__animated animate__bounceInRight');
      // // }
      // else if ((positiontop > 2955) && (positiontop < 3033)) {
      //   $('#contact').addClass('animate__animated animate__bounceInLeft');
      // }

  //   });
  // });
  
  
  
  return (
    <>
      <Loading />
      <Intro/>
      <About/>
      <Projects/>
      <Contact/>
      {/* <div class="cursor"></div> */}
              
            {/* </div> */}
    </>
  );
}
export default App;
